import { Component, inject, OnInit } from "@angular/core";

import { RouterOutlet } from "@angular/router";

import { MatDialog } from "@angular/material/dialog";

import { LeftMenuComponent } from "../../shared/components/left-menu/left-menu.component";

import { DialogPositionClass } from "../../shared/enums/dialogs.enum";

import { MenuItem } from "../../shared/models/menu-item.model";

import { NotificationBellComponent } from "../../shared/components/notification-bell/notification-bell.component";

import { WebSocketsService } from "../../shared/services/web-sockets.service";

import { ApiService } from "../../shared/services/api/api.service";

import { API_ENDPOINTS } from "../../shared/services/api/api-endpoints";

import { BusinessSalonContextService } from "../../shared/services/api/business-salon-context.service";

import { environment } from "../../../environments/environment";

@Component({
  selector: "app-business",

  standalone: true,

  imports: [RouterOutlet, LeftMenuComponent, NotificationBellComponent],

  templateUrl: "./business.component.html",

  styleUrl: "./business.component.scss",
})
export class BusinessComponent implements OnInit {
  private dialog = inject(MatDialog);

  private apiService = inject(ApiService);

  private salonContext = inject(BusinessSalonContextService);

  assetUrl = environment.assetBaseUrl;

  constructor(private wsService: WebSocketsService) {}

  menuItems: MenuItem[] = [
    {
      label: "Overview",
      link: "overview",
      icon: this.assetUrl + "icons/menu-home.svg",
      alt: "Overview icon",
    },

    {
      label: "Your Appointments",
      link: "appointments",
      icon: this.assetUrl + "icons/menu-list.svg",
      alt: "Your Appointments icon",
    },

    {
      label: "Services",
      link: "services",
      icon: this.assetUrl + "icons/menu-services.svg",
      alt: "Services icon",
    },

    {
      label: "Sales & Finance",
      link: "sales-finance",
      icon: this.assetUrl + "icons/menu-sales-finances.svg",
      alt: "Sales and Finance icon",
    },

    {
      label: "Customer Management",
      link: "customer-relationship",
      icon: this.assetUrl + "icons/menu-user.svg",
      alt: "Customer Relationship icon",
    },

    {
      label: "Employee Management",
      link: "employee-management",
      icon: this.assetUrl + "icons/menu-employees.svg",
      alt: "Employee Management icon",
    },

    {
      label: "Promotions",
      link: "promotion",
      icon: this.assetUrl + "icons/menu-percent.svg",
      alt: "Promotion icon",
    },

    {
      label: "Account & Store Settings",
      link: "account",
      icon: this.assetUrl + "icons/menu-account.svg",
      alt: "Account and Store Settings icon",
    },
  ];

  ngOnInit(): void {
    this.loadBusinessSalons();
  }

  /*
   * ======================================================
   * Load ALL salon pages
   * ======================================================
   */

  private loadBusinessSalons(): void {
    const allSalons: any[] = [];

    const visitedUrls = new Set<string>();

    const fetchPage = (url: string): void => {
      /*
       * Prevent accidental pagination loops.
       */
      if (visitedUrls.has(url)) {
        console.error("Salon pagination loop detected:", url);

        return;
      }

      visitedUrls.add(url);

      console.log("Fetching salon page:", url);

      this.apiService.request<any>(url, "GET").subscribe({
        next: (response: any) => {
          const results = Array.isArray(response)
            ? response
            : (response?.results ??
              response?.data?.results ??
              response?.salons ??
              (Array.isArray(response?.data) ? response.data : []));

          allSalons.push(...results);

          const nextUrl = response?.next ?? response?.data?.next ?? null;

          console.log("Next salon page:", nextUrl);

          if (nextUrl && !visitedUrls.has(nextUrl)) {
            fetchPage(nextUrl);

            return;
          }

          this.salonContext.setSalons(
            allSalons.map((salon: any) => ({
              salon_id: String(salon.salon_id ?? salon.id),

              name: salon.name ?? salon.salon_name ?? "Salon",

              city: salon.city ?? null,
            })),
          );
        },

        error: (error) => {
          console.error("Unable to initialize salon context:", error);
        },
      });
    };

    fetchPage(API_ENDPOINTS.salons.list);
  }

  openMenuDialog(): void {
    this.dialog.open(LeftMenuComponent, {
      panelClass: DialogPositionClass.left,

      data: {
        items: this.menuItems,
      },
    });
  }
}
